module.exports = __webpack_public_path__ + "fonts/MaisonNeueExtendedBlack.d5d8b66.ttf";